module.exports = __webpack_public_path__ + "static/media/company-profile-inputs.a5ae8df4.png";